export default __webpack_public_path__ + "src/assets/assets.47c34226c6127169ebc36912e191f282.svg";